import data from './data';

/*****************************************
 * EXPORTED FUNCTIONS
 *****************************************/

const calcFunctions = {
  calcInit0,
  calcInit1,
  initData,
  calcNextPoint,
  getRotateDegree,
};

export default calcFunctions;

/*****************************************
 * CALCULATIONS
 *****************************************/

function tmrPID_Ctrl_Tick(calcData, currSpeed) {
  let error = currSpeed - calcData.PV;
  calcData.integral = calcData.integral + error * data.Dt;
  let derivative = (error - calcData.preError) / data.Dt;

  calcData.output =
    calcData.Kp * error +
    calcData.Ki * calcData.integral +
    calcData.Kd * derivative;

  // console.log("<debug time>", timeE);
  // console.log('<>PV=', PV, 'setpoint=', setpoint, 'output=', output);
  // console.log("<>derivative=", derivative, "integral=", integral);
  //console.log("<> error=", error, "pre=", preError, "output=", output);
  calcData.preError = error;
}

function tmrPV_Tick(calcData) {
  //console.log("***********PV:", PV, "output=", output);
  const noise = (Math.random() - 0.5) * calcData.noiseRatio;
  calcData.PV = calcData.PV + calcData.output * 0.2 - calcData.PV * 0.1 + noise;
  calcData.PV = Math.min(calcData.PV, 150);
  calcData.PV = Math.max(calcData.PV, 0);
}

function calcPid(calcData) {
  let idx = calcData.currIdx;

  let sampleIdx = calcData.sampleIdx;
  if (sampleIdx % data.speedChangeRate === 0) {
    calcData.speedArrIdx++;
    calcData.speedArrIdx = calcData.speedArrIdx % calcData.speedArr.length;
  }
  let currSpeed = calcData.speedArr[calcData.speedArrIdx];
  calcData.values.speed[idx] = currSpeed;

  if (sampleIdx % calcData.rate === 0) {
    tmrPID_Ctrl_Tick(calcData, currSpeed);
  }
  if (sampleIdx % data.tmrPV_rate === 0) {
    tmrPV_Tick(calcData);
  }

  calcData.values.pid[idx] = calcData.PV;
}

function getRotateDegree(data) {
  // calculate rotation degree of speedometer
  // based on the last speed value
  const speed = data.calcData.values.pid[
    data.calcData.values.pid.length - 1
  ];

  let rotateDegree = '180deg';
  if (speed !== undefined && speed !== 0) {
    const slope = (300 - 160) / 140;
    rotateDegree = `${220 + (speed - 20) * slope}deg`;
  }
  
  return rotateDegree;
}

function calcNextPoint(state) {
  const calcData = JSON.parse(JSON.stringify(state.data.calcData));
  calcData.rate = state.rate;
  calcData.Ki = state.Ki;

  let first;
  if (calcData.numOfPoints === calcData.currIdx) {
    // array is full -> remove first
    [first, ...calcData.values.speed] = calcData.values.speed;
    [first, ...calcData.values.pid] = calcData.values.pid;
    calcData.currIdx--;
  }

  calcPid(calcData);
  calcData.currIdx++;
  calcData.sampleIdx++;

  const chartData = JSON.parse(JSON.stringify(state.data.chartData));
  chartData.values.speed = [...calcData.values.speed];
  chartData.values.pid = [...calcData.values.pid];

  const dataBuffer = {
    calcData,
    chartData,
  };

  return dataBuffer;
}

/*****************************************
 * initializations
 *****************************************/

// all variables are declares in data.js

function initData(exampleIdx) {
  const dataBuffer = {
    calcData: {
      currIdx: 0,
      sampleIdx: 0,
      rate: 2,
      output: 30,
      integral: 0,
      preError: 0,
      speedArr: data.examples[exampleIdx].speedArr,
      speedArrIdx: data.examples[exampleIdx].speedArr.length - 1,
      noiseRatio: data.examples[exampleIdx].noiseRatio,
      PV: data.examples[exampleIdx].PV,
      Kp: data.examples[exampleIdx].Kp,
      // Ki: data.examples[exampleIdx].Ki,
      Kd: data.examples[exampleIdx].Kd,
      numOfPoints: data.examples[exampleIdx].numOfPoints,
      values: {
        speed: [],
        pid: [],
      },
    },

    chartData: {
      title: data.chartTitle,
      numOfPoints: data.examples[exampleIdx].numOfPoints,
      xLabels: [],
      legendLabels: data.chartLegendLabels,
      values: {
        speed: [],
        pid: [],
      },
    },
  };

  for (let i = 0; i < dataBuffer.chartData.numOfPoints; i++) {
    dataBuffer.chartData.xLabels.push(i);
  }

  return dataBuffer;
}

function calcInit0() {
  return initData(0);
}

function calcInit1() {
  return initData(1);
}
